
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/article/teamsreminder-project-management-deadline-tracking",
      function () {
        return require("private-next-pages/article/teamsreminder-project-management-deadline-tracking.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/article/teamsreminder-project-management-deadline-tracking"])
      });
    }
  